//Force encoding -> _Íì_ 
exports.getWalls = function() {
	return[
		{	"id" : 1
			,"name" : "Block común de Cemento - Arena "
			,"link" : ""
			,"r_value" : 1.9
			,"u_value" : 2.9806
			,"thermal_resistance" : 0.3355
			,"complies_2001" : "No"
		},
		{	"id" : 2
			,"name" : "Block común de Cemento - Arena (12 cm ) con acabados"
			,"link" : ""
			,"r_value" : 2.03
			,"u_value" : 2.791
			,"thermal_resistance" : 0.3583
			,"complies_2001" : "No"
		},
		{	"id" : 3
			,"name" : "Block común de Cemento - Arena (15 cm ) con acabados"
			,"link" : ""
			,"r_value" : 2.19
			,"u_value" : 2.5954
			,"thermal_resistance" : 0.3853
			,"complies_2001" : "No"
		},
		{	"id" : 4
			,"name" : "Block común de Cemento - Arena (20 cm ) con acabados"
			,"link" : ""
			,"r_value" : 2.44
			,"u_value" : 2.3234
			,"thermal_resistance" : 0.4304
			,"complies_2001" : "No"
		},
		{	"id" : 5
			,"name" : "Muro de concreto armado de 12 cm de espesor"
			,"link" : ""
			,"r_value" : 1.529624
			,"u_value" : 3.71333085777943
			,"thermal_resistance" : 0.2693
			,"complies_2001" : "No"
		},
		{	"id" : 6
			,"name" : "Muro de concreto armado de 12 cm de espesor con acabados"
			,"link" : ""
			,"r_value" : 1.81
			,"u_value" : 3.1328
			,"thermal_resistance" : 0.3192
			,"complies_2001" : "No"
		},
		{	"id" : 7
			,"name" : "Ecomuro 12  "
			,"link" : "https://ladrilleramecanizada.com/producto/ecomuro"
			,"r_value" : 4.127088
			,"u_value" : 1.37627305257363
			,"thermal_resistance" : 0.7266
			,"complies_2001" : "No"
		},
		{	"id" : 8
			,"name" : "Ecomuro 12 relleno con 3 cm de poliestireno (EPS)"
			,"link" : "https://ladrilleramecanizada.com/producto/ecomuro"
			,"r_value" : 6.118496
			,"u_value" : 0.928332714444857
			,"thermal_resistance" : 1.0772
			,"complies_2001" : "Si"
		},
		{	"id" : 9
			,"name" : "Ecomuro 12 relleno de poliestireno (EPS)"
			,"link" : "https://ladrilleramecanizada.com/producto/ecomuro"
			,"r_value" : 8.59668
			,"u_value" : 0.660720185001652
			,"thermal_resistance" : 1.5135
			,"complies_2001" : "Si"
		},
		{	"id" : 10
			,"name" : "Ecomuro 14 "
			,"link" : "https://ladrilleramecanizada.com/producto/ecomuro"
			,"r_value" : 4.443464
			,"u_value" : 1.27828198900677
			,"thermal_resistance" : 0.7823
			,"complies_2001" : "No"
		},
		{	"id" : 11
			,"name" : "Ecomuro 14 relleno con 4 cm de poliestireno (EPS)"
			,"link" : "https://ladrilleramecanizada.com/producto/ecomuro"
			,"r_value" : 6.823384
			,"u_value" : 0.832431532506451
			,"thermal_resistance" : 1.2013
			,"complies_2001" : "Si"
		},
		{	"id" : 12
			,"name" : "Ecomuro 14 relleno con 8 cm de poliestireno (EPS) "
			,"link" : "https://ladrilleramecanizada.com/producto/ecomuro"
			,"r_value" : 10.272848
			,"u_value" : 0.552913856021232
			,"thermal_resistance" : 1.8086
			,"complies_2001" : "Si"
		},
		{	"id" : 13
			,"name" : "Ecomuro 19"
			,"link" : "https://ladrilleramecanizada.com/producto/ecomuro"
			,"r_value" : 5.162552
			,"u_value" : 1.10023104852019
			,"thermal_resistance" : 0.9089
			,"complies_2001" : "No"
		},
		{	"id" : 14
			,"name" : "Ecomuro 19 relleno de poliestireno (EPS)"
			,"link" : "https://ladrilleramecanizada.com/producto/ecomuro"
			,"r_value" : 12.130208
			,"u_value" : 0.468252481738153
			,"thermal_resistance" : 2.1356
			,"complies_2001" : "Si"
		},
		{	"id" : 15
			,"name" : "Ecomuro Plus"
			,"link" : "https://ladrilleramecanizada.com/producto/ecomuro"
			,"r_value" : 4.682592
			,"u_value" : 1.21300339640951
			,"thermal_resistance" : 0.8244
			,"complies_2001" : "No"
		},
		{	"id" : 16
			,"name" : "Ecomuro Plus relleno"
			,"link" : "https://ladrilleramecanizada.com/producto/ecomuro"
			,"r_value" : 9.882632
			,"u_value" : 0.574745675038795
			,"thermal_resistance" : 1.7399
			,"complies_2001" : "Si"
		},
		{	"id" : 17
			,"name" : "Tabique Porotón 13x40x20"
			,"link" : "https://ladrilleramecanizada.com/producto/ladrillo-ligero"
			,"r_value" : 4.7712
			,"u_value" : 1.19047619047619
			,"thermal_resistance" : 0.84
			,"complies_2001" : "No"
		},
		{	"id" : 18
			,"name" : "Tabique Porotón 13x40x20 relleno de 7 cm poliestireno (EPS)"
			,"link" : "https://ladrilleramecanizada.com/producto/ladrillo-ligero"
			,"r_value" : 8.552376
			,"u_value" : 0.664142923557149
			,"thermal_resistance" : 1.5057
			,"complies_2001" : "Si"
		},
		{	"id" : 19
			,"name" : "Block Porotón 13x40x20"
			,"link" : "https://ladrilleramecanizada.com/producto/ladrillo-ligero"
			,"r_value" : 4.92456
			,"u_value" : 1.15340253748558
			,"thermal_resistance" : 0.867
			,"complies_2001" : "No"
		},
		{	"id" : 20
			,"name" : "Block Porotón 13x40x20 relleno de 7 cm poliestireno (EPS)"
			,"link" : "https://ladrilleramecanizada.com/producto/ladrillo-ligero"
			,"r_value" : 9.28396
			,"u_value" : 0.611807892321811
			,"thermal_resistance" : 1.6345
			,"complies_2001" : "Si"
		},
		{	"id" : 21
			,"name" : "Lámina Calibre 26"
			,"link" : ""
			,"r_value" : 1.138272
			,"u_value" : 4.99001996007984
			,"thermal_resistance" : 0.2004
			,"complies_2001" : "No"
		},
		{	"id" : 22
			,"name" : "Tecnopanel 1.0\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 5.15107764482431
			,"u_value" : 1.10268188360685
			,"thermal_resistance" : 0.906879867046534
			,"complies_2001" : "No"
		},
		{	"id" : 23
			,"name" : "Tecnopanel 1.25\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 6.154848
			,"u_value" : 0.922849760059062
			,"thermal_resistance" : 1.0836
			,"complies_2001" : "Si"
		},
		{	"id" : 24
			,"name" : "Tecnopanel 1.5\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 7.157936
			,"u_value" : 0.793524837327408
			,"thermal_resistance" : 1.2602
			,"complies_2001" : "Si"
		},
		{	"id" : 25
			,"name" : "Tecnopanel 2\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 9.16468
			,"u_value" : 0.619770684846607
			,"thermal_resistance" : 1.6135
			,"complies_2001" : "Si"
		},
		{	"id" : 26
			,"name" : "Tecnopanel 3\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 13.1776
			,"u_value" : 0.431034482758621
			,"thermal_resistance" : 2.32
			,"complies_2001" : "Si"
		},
		{	"id" : 27
			,"name" : "Tecnopanel 4\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 17.19052
			,"u_value" : 0.330414670411366
			,"thermal_resistance" : 3.0265
			,"complies_2001" : "Si"
		},
		{	"id" : 28
			,"name" : "Tecnopanel 5\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 21.204008
			,"u_value" : 0.267873884974954
			,"thermal_resistance" : 3.7331
			,"complies_2001" : "Si"
		},
		{	"id" : 29
			,"name" : "Tecnopanel 6\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 25.216928
			,"u_value" : 0.225245517614199
			,"thermal_resistance" : 4.4396
			,"complies_2001" : "Si"
		},
		{	"id" : 30
			,"name" : "Tecnopanel 7\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 29.230416
			,"u_value" : 0.194318137654969
			,"thermal_resistance" : 5.1462
			,"complies_2001" : "Si"
		},
		{	"id" : 31
			,"name" : "Tecnopanel 8\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 33.243336
			,"u_value" : 0.170861311873153
			,"thermal_resistance" : 5.8527
			,"complies_2001" : "Si"
		},
		{	"id" : 32
			,"name" : "Tecnopanel 9\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 37.256256
			,"u_value" : 0.152457616782534
			,"thermal_resistance" : 6.5592
			,"complies_2001" : "Si"
		},
		{	"id" : 33
			,"name" : "Tecnopanel 10\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 41.269744
			,"u_value" : 0.13763109361667
			,"thermal_resistance" : 7.2658
			,"complies_2001" : "Si"
		},
		{	"id" : 34
			,"name" : "Block Contec AAC 2.5/B 10cm"
			,"link" : ""
			,"r_value" : 6.30179400846068
			,"u_value" : 0.901330635748191
			,"thermal_resistance" : 1.10947077613744
			,"complies_2001" : "Si"
		},
		{	"id" : 35
			,"name" : "Block Contec AAC 2.5/B 12.5cm"
			,"link" : ""
			,"r_value" : 7.59270309936977
			,"u_value" : 0.748086672909872
			,"thermal_resistance" : 1.33674350341017
			,"complies_2001" : "Si"
		},
		{	"id" : 36
			,"name" : "Block Contec AAC 2.5/B 15cm"
			,"link" : ""
			,"r_value" : 8.88361219027886
			,"u_value" : 0.639379553985427
			,"thermal_resistance" : 1.5640162306829
			,"complies_2001" : "Si"
		},
		{	"id" : 37
			,"name" : "Block Contec AAC 2.5/B 17.5cm"
			,"link" : ""
			,"r_value" : 10.1745212811879
			,"u_value" : 0.558257223413741
			,"thermal_resistance" : 1.79128895795562
			,"complies_2001" : "Si"
		},
		{	"id" : 38
			,"name" : "Block Contec AAC 2.5/B 20cm"
			,"link" : ""
			,"r_value" : 11.465430372097
			,"u_value" : 0.495402249689919
			,"thermal_resistance" : 2.01856168522835
			,"complies_2001" : "Si"
		},
		{	"id" : 39
			,"name" : "Block Contec AAC 2.5/B 25cm"
			,"link" : ""
			,"r_value" : 14.0472485539152
			,"u_value" : 0.404349647420233
			,"thermal_resistance" : 2.47310713977381
			,"complies_2001" : "Si"
		},
		{	"id" : 40
			,"name" : "Block Contec AAC 2.5/B 30cm"
			,"link" : ""
			,"r_value" : 16.6290667357334
			,"u_value" : 0.341570581817109
			,"thermal_resistance" : 2.92765259431926
			,"complies_2001" : "Si"
		},
		{	"id" : 41
			,"name" : "Block Contec AAC 5.0/B 10cm"
			,"link" : ""
			,"r_value" : 4.68815764482431
			,"u_value" : 1.21156335394794
			,"thermal_resistance" : 0.825379867046534
			,"complies_2001" : "No"
		},
		{	"id" : 42
			,"name" : "Block Contec AAC 5.0/B 12.5cm"
			,"link" : ""
			,"r_value" : 5.57565764482431
			,"u_value" : 1.01871390996765
			,"thermal_resistance" : 0.981629867046534
			,"complies_2001" : "No"
		},
		{	"id" : 43
			,"name" : "Block Contec AAC 5.0/B 15cm"
			,"link" : ""
			,"r_value" : 6.46315764482431
			,"u_value" : 0.878827395545355
			,"thermal_resistance" : 1.13787986704653
			,"complies_2001" : "Si"
		},
		{	"id" : 44
			,"name" : "Block Contec AAC 5.0/B 17.5cm"
			,"link" : ""
			,"r_value" : 7.35065764482431
			,"u_value" : 0.772719976150618
			,"thermal_resistance" : 1.29412986704653
			,"complies_2001" : "Si"
		},
		{	"id" : 45
			,"name" : "Block Contec AAC 5.0/B 20cm"
			,"link" : ""
			,"r_value" : 8.23815764482431
			,"u_value" : 0.689474545752169
			,"thermal_resistance" : 1.45037986704653
			,"complies_2001" : "Si"
		},
		{	"id" : 46
			,"name" : "Block Contec AAC 5.0/B 25cm"
			,"link" : ""
			,"r_value" : 10.0131576448243
			,"u_value" : 0.567253627823979
			,"thermal_resistance" : 1.76287986704653
			,"complies_2001" : "Si"
		},
		{	"id" : 47
			,"name" : "Block Contec AAC 5.0/B 30cm"
			,"link" : ""
			,"r_value" : 11.7881576448243
			,"u_value" : 0.481839501229766
			,"thermal_resistance" : 2.07537986704653
			,"complies_2001" : "Si"
		},
		{	"id" : 48
			,"name" : "Panel Contec AAC 3.5 15cm"
			,"link" : ""
			,"r_value" : 7.2238719305386
			,"u_value" : 0.786281935036535
			,"thermal_resistance" : 1.27180843847511
			,"complies_2001" : "Si"
		},
		{	"id" : 49
			,"name" : "Panel Contec AAC 3.5 17.5cm"
			,"link" : ""
			,"r_value" : 8.23815764482431
			,"u_value" : 0.689474545752169
			,"thermal_resistance" : 1.45037986704653
			,"complies_2001" : "Si"
		},
		{	"id" : 50
			,"name" : "Panel Contec AAC 3.5 20cm"
			,"link" : ""
			,"r_value" : 9.25244335911003
			,"u_value" : 0.61389189639377
			,"thermal_resistance" : 1.62895129561796
			,"complies_2001" : "Si"
		},
		{	"id" : 51
			,"name" : "Panel Contec AAC 3.5 25cm"
			,"link" : ""
			,"r_value" : 11.2810147876815
			,"u_value" : 0.50350080262304
			,"thermal_resistance" : 1.98609415276082
			,"complies_2001" : "Si"
		},
		{	"id" : 52
			,"name" : "Panel Contec AAC 3.5 30cm"
			,"link" : ""
			,"r_value" : 13.3095862162529
			,"u_value" : 0.426760074108383
			,"thermal_resistance" : 2.34323700990368
			,"complies_2001" : "Si"
		},
		{	"id" : 53
			,"name" : "Panel Contec AAC 5.0 15cm"
			,"link" : ""
			,"r_value" : 6.46315764482431
			,"u_value" : 0.878827395545355
			,"thermal_resistance" : 1.13787986704653
			,"complies_2001" : "Si"
		},
		{	"id" : 54
			,"name" : "Panel Contec AAC 5.0 17.5cm"
			,"link" : ""
			,"r_value" : 7.35065764482431
			,"u_value" : 0.772719976150618
			,"thermal_resistance" : 1.29412986704653
			,"complies_2001" : "Si"
		},
		{	"id" : 55
			,"name" : "Panel Contec AAC 5.0 20cm"
			,"link" : ""
			,"r_value" : 8.23815764482431
			,"u_value" : 0.689474545752169
			,"thermal_resistance" : 1.45037986704653
			,"complies_2001" : "Si"
		},
		{	"id" : 56
			,"name" : "Panel Contec AAC 5.0 25cm"
			,"link" : ""
			,"r_value" : 10.0131576448243
			,"u_value" : 0.567253627823979
			,"thermal_resistance" : 1.76287986704653
			,"complies_2001" : "Si"
		},
		{	"id" : 57
			,"name" : "Panel Contec AAC 5.0 30cm"
			,"link" : ""
			,"r_value" : 11.7881576448243
			,"u_value" : 0.481839501229766
			,"thermal_resistance" : 2.07537986704653
			,"complies_2001" : "Si"
		}
	];
}
